module.exports = __webpack_public_path__ + "img/patient-management-slide 2.66308d9d.gif";